import forms from '@/libs/forms';

export default {
  schema: () => ({
    groups: [
      {
        legend: 'One time ACH Interest Payment Request data',
        fields: [
          forms.currency('Authorized Amount $', 'authorizedAmount', true, '6'),
          forms.checkbox(`By marking this checkbox you are confirming that you are authorizing
                          Anchor Loans, LP to a one-time withdrawal of funds in the amount specified above from the account
                          listed below.`,
          'authorized',
          '12',
          true,
          ),
        ],
      },
    ],
  }),
  options: forms.options('ach-payment-', true),
};



// WEBPACK FOOTER //
// ./src/components/my_deals/actions/ach_payment/resources/schema.js